// // import './scss/style.scss';
// import React, { Component } from 'react';
// import { Route, Switch, Redirect } from 'react-router-dom';
// import { connect } from 'react-redux';
// import jwtDecode from 'jwt-decode';

// // --- STYLES & REDUX ---

// import '@fortawesome/fontawesome-free/css/all.min.css';
// import { handlelogin, getAllUsers, logout } from "./actions/loginAction";
// import { LOGINAUTH } from './actions/types';
// import { formatCurrency } from '../src/appoinmentApp/utils/currencyHelper'; 
// // --- STATICALLY IMPORTED ADMIN PAGE COMPONENTS ---
// import AdminDashboardMain from './appoinmentApp/admin/AdminDashboardMain';
// import appointmentList from './appoinmentApp/admin/appointmentList';
// import Specialities from './appoinmentApp/admin/Specialities';
// import doctorList from './appoinmentApp/admin/doctorList';
// import PatientListAdmin from './appoinmentApp/admin/PatientList';
// import ReviewsAdmin from './appoinmentApp/admin/Reviews';
// import TransactionsList from './appoinmentApp/admin/TransactionsList';
// import Settings from './appoinmentApp/admin/Settings';
// import Invoicereport from './appoinmentApp/admin/Invoicereport';
// import Profile from './appoinmentApp/admin/Profile';
// import FormBasicInputs from './appoinmentApp/admin/FormBasicInputs';
// import FormHorizontal from './appoinmentApp/admin/FormHorizontal';
// import FormInputGroups from './appoinmentApp/admin/FormInputGroups';
// import FormMask from './appoinmentApp/admin/FormMask';
// import FormValidation from './appoinmentApp/admin/FormValidation';
// import FormVertical from './appoinmentApp/admin/FormVertical';
// import Basictables from './appoinmentApp/admin/Basictables';
// import dataTables from './appoinmentApp/admin/dataTables';
// import AdminPayoutDashboard from './appoinmentApp/admin/AdminPayoutDashboard';
// import AdminDoctorBlogPage from './appoinmentApp/admin/AdminDoctorBlogPage';
// import createOffers from './appoinmentApp/admin/createOffers';
// import AllOffers from './appoinmentApp/admin/AllOffers';
// import CurrencySettings from './appoinmentApp/admin/CurrencySettings';
// import NotificationSettings from './appoinmentApp/admin/NotificationSettings';
// import AdminBusinessAndAddonPage from './appoinmentApp/admin/AdminBusinessAndAddonPage';
// import PaymentSettings from './appoinmentApp/admin/PaymentSettings';
// import VideoSettings from './appoinmentApp/admin/VideoSettings';
// // --- STATICALLY IMPORTED DOCTOR PAGE COMPONENTS ---
// import DoctorDashboardMain from './appoinmentApp/doctor/DoctorDashboardMain';
// import Appointments from './appoinmentApp/doctor/Appointments';
// import PatientListDoctor from './appoinmentApp/doctor/PatientList';
// import ScheduleTime from './appoinmentApp/doctor/ScheduleTime';
// import DoctorInvoices from './appoinmentApp/doctor/DoctorInvoices';
// import ReviewsDoctor from './appoinmentApp/doctor/Reviews';
// import DoctorChat from './appoinmentApp/doctor/DoctorChat';
// import ReminderTab from './appoinmentApp/doctor/ReminderTab';
// import Exercisechart from './appoinmentApp/doctor/Exercisechart'
// import DoctorProfileSettings from './appoinmentApp/doctor/DoctorProfileSettings';
// import SocialMedia from './appoinmentApp/doctor/SocialMedia';
// import DoctorChangePassword from './appoinmentApp/doctor/DoctorChangePassword';
// import PatientProfilePage from './appoinmentApp/doctor/PatientProfilePage';
// import DoctorTransactions from './appoinmentApp/doctor/DoctorTransactions';
// import ReportSettingsEditor from './appoinmentApp/doctor/ReportSettingsEditor';
// import PayoutHistory from './appoinmentApp/doctor/PayoutHistory';
// import RecordingsLibrary from './appoinmentApp/doctor/RecordingsLibrary';
// import PlanSelection from './appoinmentApp/doctor/PlanSelection';
// import AddBlogs from './appoinmentApp/doctor/AddBlogs';
// import MyBlogs from './appoinmentApp/doctor/MyBlogs';
// import ViewOfferPage from './appoinmentApp/Pages/AllOfferViewPage'
// import UIShowcase from '../src/appoinmentApp/Pages/UIShowcase'
// // --- STATICALLY IMPORTED PATIENT PAGE COMPONENTS ---
// import PatientDashbordMain from './appoinmentApp/patient/PatientDashbordMain';
// import Favourites from './appoinmentApp/patient/favourites';
// import PatientProfileSettings from './appoinmentApp/patient/PatientProfileSettings';
// import AddFamilyMembers from './appoinmentApp/patient/addFamilyMembers';
// import PatientChangePassword from './appoinmentApp/patient/PatientChangePassword';
// import PatientChat from './appoinmentApp/patient/PatientChat';
// import DoctorsBlogPage from './appoinmentApp/Pages/DoctorsBlogPage';
// // --- STATICALLY FOOTER PAGE COMPONENTS ---
// import Aboutus from './appoinmentApp/Footer/Aboutus';
// import Contactus from './appoinmentApp/Footer/Contactus';
// import Careers from './appoinmentApp/Footer/Careers';
// import PartnerWithUs from './appoinmentApp/Footer/PartnerWithUs';
// import PrivacyPolicy from './appoinmentApp/Footer/PrivacyPolicy';
// import TermsConditions from './appoinmentApp/Footer/TermsConditions';
// import RefundCancellationPolicy from './appoinmentApp/Footer/RefundCancellationPolicy';
// import Brochure from './appoinmentApp/Footer/Brochure';
// // --- STATICALLY LOGE PAGE COMPONENTS ---
// import MedisevasHospitalErp from './appoinmentApp/logepages/Healthcare Software/MedisevasHospitalErp';
// import MedisevasAppointmentPortal from './appoinmentApp/logepages/Healthcare Software/MedisevasAppointmentPortal';
// import HospitalAnalyticsManagement from './appoinmentApp/logepages/Healthcare Software/HealthCareAnalytics';
// import QueueManagement from './appoinmentApp/logepages/Healthcare Software/QueueManagements';
// import TeleHealthCareManagement from './appoinmentApp/logepages/Healthcare Software/TeleHealthCareManagements';
// import MedisevasHealthCareImaging from './appoinmentApp/logepages/Healthcare Software/MedisevasHealthCareImaging';
// import MateriaMedicaRepertory from './appoinmentApp/logepages/Healthcare Software/MateriaMedicaandRepertory';
// import PathologyLabManagement from './appoinmentApp/logepages/Laboratory Software/PathologyLabManagement';
// import RadiologyLabManagement from './appoinmentApp/logepages/Laboratory Software/RadiologyLabManagement'; 
// import DentalLabManagement from './appoinmentApp/logepages/Laboratory Software/DentalLabManagement'; 
// import EmbryologyLabManagement from './appoinmentApp/logepages/Laboratory Software/EmbryologyLabManagement'; 
// import EggSpermBankLabManagement from './appoinmentApp/logepages/Laboratory Software/Egg&SpermBankSoftware';    
// import BloodBankLabManagement from './appoinmentApp/logepages/Laboratory Software/BloodBankManagement'; 
// import AyurvedicClinicManagement from './appoinmentApp/logepages/For Clinic/AyurvedicClinicalModule';
// import DentalClinicManagement from './appoinmentApp/logepages/For Clinic/DentalClinicalModule';
// import GynecologyClinicalModule from './appoinmentApp/logepages/For Clinic/GynecologyClinicalModule'; 
// import PediatricsClinicalModule from './appoinmentApp/logepages/For Clinic/PediatricClinicalModule';
// import OphthalmologyClinicalModule from './appoinmentApp/logepages/For Clinic/OphthalmologyClinicalModule'; 
// import HomeopathyClinicalModule from './appoinmentApp/logepages/For Clinic/HomeopathyClinicalModule';
// import IVFClinicalModule from './appoinmentApp/logepages/For Clinic/IVFClinicalModule';
// import MedicineClinicalModule from './appoinmentApp/logepages/For Clinic/MedicineClinicalModule';
// import OrthopedicClinicalModule from './appoinmentApp/logepages/For Clinic/OrthopedicClinicalModule';
// import PhysiotherapyClinicalModule from './appoinmentApp/logepages/For Clinic/PhysiotherapyClinicalModule';
// import DietChart from './appoinmentApp/doctor/DietCharts';
// import LabsAndCenters from './appoinmentApp/LabsAndCenters';
// import HomeAndHealthcare from './appoinmentApp/HomeAndHealthcares';
// import HealthInsurance from './appoinmentApp/HealthInsurance';
// import PharmacyAndMedicines from './appoinmentApp/PharmacyAndMedicines';
// // section pages 
// import NavStrip from './appoinmentApp/section/NavStrip';
// import OfferSection from './appoinmentApp/section/OfferSection';
// import BlogSection from './appoinmentApp/section/BlogSection';
// import FaqSection from './appoinmentApp/section/FaqSection';
// import DownloadSection from './appoinmentApp/section/DownloadSection';
// // --- LAZY-LOADED LAYOUTS & PUBLIC PAGES ---
// const MessageModal = React.lazy(() => import('./appoinmentApp/Pages/MessageModel'));
// const AdminDashboardLayout = React.lazy(() => import('./appoinmentApp/admin/AdminDashboard'));
// const DoctorDashboardLayout = React.lazy(() => import('./appoinmentApp/doctor/DoctorDashboard'));
// const PatientDashboardLayout = React.lazy(() => import('./appoinmentApp/patient/Patientdashboard'));
// const AppoinmentApp = React.lazy(() => import('./appoinmentApp/AppoinmentApp'));
// const Login = React.lazy(() => import('./appoinmentApp/Pages/LoginPage'));
// const Register = React.lazy(() => import('./appoinmentApp/Pages/Register'));
// const Forgot_Password = React.lazy(() => import('./appoinmentApp/Pages/ForgotPassword'));
// const ResetPassword = React.lazy(() => import('./appoinmentApp/Pages/ResetPassword'));
// const SearchDoctor = React.lazy(() => import('./appoinmentApp/Pages/Searchdoctors'));
// const Doctorprofile = React.lazy(() => import('./appoinmentApp/patient/Doctorprofile'));
// const Booking = React.lazy(() => import('./appoinmentApp/patient/booking'));
// const Checkout = React.lazy(() => import('./appoinmentApp/patient/Checkout'));
// const BookingSucess = React.lazy(() => import('./appoinmentApp/patient/bookingSuccess'));
// const VoiceCall = React.lazy(() => import('./appoinmentApp/Pages/VoiceCall'));
// const VideoCall = React.lazy(() => import('./appoinmentApp/Pages/VideoCall'));
// const Calender = React.lazy(() => import('./appoinmentApp/Pages/Calendar'));
// const Invoice = React.lazy(() => import('./appoinmentApp/Pages/Invoices'));
// const Invoiceview = React.lazy(() => import('./appoinmentApp/Pages/Invoiceview'));
// const Components = React.lazy(() => import('./appoinmentApp/Pages/Componants'));
// const StarterPage = React.lazy(() => import('./appoinmentApp/Pages/StarterPage'));
// const PatientVideoCall = React.lazy(() => import('./appoinmentApp/Pages/PatientVideoCall'));
// const DoctorVideoCall = React.lazy(() => import('./appoinmentApp/Pages/DoctorVideoCall'));
// const PaymentStatus = React.lazy(() => import('./appoinmentApp/Pages/PaymentStatus'));
// const SpecialityDoctorsPage = React.lazy(() => import('./appoinmentApp/Pages/SpecialityDoctorsPage'));
// const AllOffersList = React.lazy(() => import('./appoinmentApp/Pages/AllOfferViewPage')); 

// // --- GLOBAL LOADING INDICATOR ---
// const loading = (
//   <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//     <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
//       <span className="sr-only">Loading...</span>
//     </div>
//   </div>
// );

// class App extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       loading: true,
//       modalShow: false,
//       modalTitle: '',
//       modalMessage: '',
//       modalVariant: 'info',
//     };
//   }
  
//   componentDidMount() {
//     this.rehydrateStateFromLocalStorage();
//   }

//   rehydrateStateFromLocalStorage = () => {
//     try {
//       const loginDataString = localStorage.getItem('loginData');
//       if (!loginDataString) {
//         this.setState({ loading: false });
//         return;
//       }

//       const loginData = JSON.parse(loginDataString);
//       const token = loginData.token;

//       if (!token || (jwtDecode(token).exp * 1000 < Date.now())) {
//         localStorage.removeItem('loginData');
//         this.setState({ loading: false });
//         return;
//       }
//        window.formatCurrency = formatCurrency; 
//       this.props.dispatch({
//         type: LOGINAUTH,
//         payload: { success: 1, data: loginData }
//       });

//     } catch (error) {
//       console.error("Failed to rehydrate state from localStorage:", error);
//       localStorage.removeItem('loginData');
//     } finally {
//       this.setState({ loading: false });
//     }
//   };

//   componentDidUpdate(prevProps) {
//     const { isAuthenticated, username, userList } = this.props;

//     // --- ONE-TIME STATUS CHECK ON LOGIN ---
//     if (isAuthenticated && !prevProps.isAuthenticated) {
//       console.log('User authenticated. Performing a one-time status check.');
//       this.props.getAllUsers();
//     }

//     if (isAuthenticated && userList && userList !== prevProps.userList && !this.state.modalShow) {
//       if (Array.isArray(userList.data) && userList.data.length > 0) {
//         const currentUserFromServer = userList.data.find(u => u.username === username);
//         if (currentUserFromServer) {
//           if (currentUserFromServer.app_status === 'disabled') {
//             this.triggerLogoutModal(
//               'Session Terminated',
//               'Your account has been disabled by an administrator. You will be logged out. Please contact the admin to activate your account.',
//               'danger'
//             );
//           }
//         } else {
//           this.triggerLogoutModal(
//             'Account Not Found',
//             'Your user account could not be found. You will be logged out.',
//             'danger'
//           );
//         }
//       }
//     }
//   }

//   triggerLogoutModal = (title, message, variant) => {
//     console.warn(`TRIGGERING LOGOUT MODAL: ${message}`);
//     this.setState({
//       modalShow: true,
//       modalTitle: title,
//       modalMessage: message,
//       modalVariant: variant,
//     });
//   }

//   handleConfirmLogout = () => {
//     this.props.logout();
//     this.setState({ modalShow: false });
//   }

//   // Enhanced PrivateRoute with subscription check
//   PrivateRoute = ({ component: Component, layout: Layout, requiresSubscription = false, ...rest }) => (
//     <Route
//       {...rest}
//       render={(props) => {
//         if (!this.props.isAuthenticated) {
//           return <Redirect to="/login" />;
//         }

//         // Check if route requires active subscription (for doctor routes)
//         if (requiresSubscription) {
//           const hospitalID = parseInt(localStorage.getItem('hospitalCode'), 10);
//           const userRole = localStorage.getItem('StaffRole');
          
//           // Only apply subscription check for doctor role
//           if (userRole === 'Admin') {
//             const currentUser = this.props.userList?.data?.find(user => 
//               user.hospitalID === hospitalID || user.username === this.props.username
//             );
            
//             if (!currentUser || currentUser.subscription_status !== 'active') {
//               // Redirect to plan selection if subscription is not active
//               return <Redirect to="/doctor/plan-selection" />;
//             }
//           }
//         }

//         return Layout ? (
//           <Layout>
//             <Component {...props} />
//           </Layout>
//         ) : (
//           <Component {...props} />
//         );
//       }}
//     />
//   );

//   // Doctor-specific route with subscription check
//   DoctorRoute = ({ component: Component, layout: Layout, requiresSubscription = true, ...rest }) => (
//     <this.PrivateRoute 
//       component={Component} 
//       layout={Layout} 
//       requiresSubscription={requiresSubscription} 
//       {...rest} 
//     />
//   );

//   // Regular private route without subscription check
//   RegularPrivateRoute = ({ component: Component, layout: Layout, ...rest }) => (
//     <this.PrivateRoute 
//       component={Component} 
//       layout={Layout} 
//       requiresSubscription={false} 
//       {...rest} 
//     />
//   );

//   render() {
//     const { modalShow, modalTitle, modalMessage, modalVariant } = this.state;

//     if (this.state.loading) {
//       return loading;
//     }

//     return (
//       <React.Suspense fallback={loading}>
//         <MessageModal
//           show={modalShow}
//           onClose={this.handleConfirmLogout}
//           title={modalTitle}
//           message={modalMessage}
//           variant={modalVariant}
//         />
//         <Switch>
//           {/* --- PUBLIC ROUTES --- */}
//           <Route exact path="/" component={AppoinmentApp} />
//           <Route exact path="/login" component={Login} />
//           <Route exact path="/register" component={Register} />
//           <Route exact path="/forgotpassword" component={Forgot_Password} />
//           <Route path="/reset-password/:token" component={ResetPassword} />
//           <Route exact path="/searchdoctors" component={SearchDoctor} />
//           <Route path="/Doctorprofile/:hospitalID" component={Doctorprofile} />
//           <Route path="/Booking/:hospitalID" component={Booking} />
//           <Route path="/Checkout/:hospitalID" component={Checkout} />
//           <Route exact path="/booking-success" component={BookingSucess} />
//           <Route exact path="/payment-status" component={PaymentStatus} />         
//           <Route exact path="/starterpage" component={StarterPage} />
//           <Route exact path="/patient-profile/:id" component={PatientProfilePage} />
//           <Route exact path="/videopage/:roomName" component={VideoCall} />
//           <Route exact path="/patient-videocall/:roomName" component={PatientVideoCall} />
//           <Route exact path="/videopage/:roomName" component={VideoCall} />
//           <Route path="/doctorvideopage/:roomName/:patientId" component={DoctorVideoCall} />
//           <Route path="/speciality-doctors/:specialityName?" component={SpecialityDoctorsPage} />
//           <Route exact path="/doctors-blog" component={DoctorsBlogPage} />
//           <Route path="/doctors-blog/:blogId" component={DoctorsBlogPage} />
//           <Route path="/offer-details" component={ViewOfferPage} />
//           <Route path="/ui-showcase" component={UIShowcase} />
//           {/* --- FOOTER PUBLIC ROUTES --- */}
//           <Route path="/careers" component={Careers} />
//           <Route path="/about-us" component={Aboutus} />
//           <Route path="/contact-us" component={Contactus} />
//           <Route path="/partner-with-us" component={PartnerWithUs} />
//           <Route path="/privacy-policy" component={PrivacyPolicy} />
//           <Route path="/terms-conditions" component={TermsConditions} />
//           <Route path="/refund-cancellation-policy" component={RefundCancellationPolicy} />
      
   
//           <Route exact path="/LabsAndCenters" component={LabsAndCenters} />
//           <Route exact path="/HomeAndHealthcare" component={HomeAndHealthcare} />
//           <Route exact path="/PharmacyAndMedicines" component={PharmacyAndMedicines} />
//           <Route exact path="/HealthInsurance" component={HealthInsurance} />
//           <Route path="/brochure" component={Brochure} />
//             {/* --- Section ROUTES --- */}
//             <Route path="/navstrip" component={NavStrip} />
//             <Route path="offer-section" component={OfferSection} />
//             <Route path="blog-section" component={BlogSection} />
//             <Route path="faq-section" component={FaqSection} />
//             <Route path="download-section" component={DownloadSection} />
//         {/* --- LOGE PUBLIC ROUTES --- */}
//           <Route path="/medisevas-hospital-erp" component={MedisevasHospitalErp} />
//           <Route path="/medisevas-appointment-Portal" component={MedisevasAppointmentPortal} />
//           <Route path="/hospital-analytics-management" component={HospitalAnalyticsManagement} />
//           <Route path="/queue-management" component={QueueManagement} />
//           <Route path="/teleHealthCare-management" component={TeleHealthCareManagement} /> 
//           <Route path="/medisevas-healthCare-imaging" component={MedisevasHealthCareImaging} /> 
//           <Route path="/materia-medica-repertory" component={MateriaMedicaRepertory} />
//           <Route path="/pathology-lab-management" component={PathologyLabManagement} />
//           <Route path="/radiology-lab-management" component={RadiologyLabManagement} />
//           <Route path="/dental-lab-management" component={DentalLabManagement} />
//           <Route path="/embryology-lab-management" component={EmbryologyLabManagement} />
//           <Route path="/egg-sperm-bank-management" component={EggSpermBankLabManagement} />
//           <Route path="/blood-bank-management" component={BloodBankLabManagement} />  
//           <Route path="/ayurvedic-clinic-management" component={AyurvedicClinicManagement} />
//           <Route path="/dental-clinic-management" component={DentalClinicManagement} /> 
//           <Route path="/gynecology-clinic-management" component={GynecologyClinicalModule} /> 
//           <Route path="/pediatrics-clinic-management" component={PediatricsClinicalModule} /> 
//           <Route path="/ophthalmology-clinic-management" component={OphthalmologyClinicalModule} /> 
//           <Route path="/homeopathy-clinic-management" component={HomeopathyClinicalModule} />
//           <Route path="/ivf-clinic-management" component={IVFClinicalModule} /> 
//           <Route path="/medicine-clinic-management" component={MedicineClinicalModule} /> 
//           <Route path="/orthopedic-clinic-management" component={OrthopedicClinicalModule} /> 
//           <Route path="/physiotherapy-clinic-management" component={PhysiotherapyClinicalModule} />
          

//           {/* --- ADMIN DASHBOARD ROUTES (No subscription required) --- */}
//           <this.RegularPrivateRoute path="/admin/payouts" component={AdminPayoutDashboard} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/dashboard" component={AdminDashboardMain} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/appointments" component={appointmentList} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/specialities" component={Specialities} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/doctors" component={doctorList} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/patients" component={PatientListAdmin} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/reviews" component={ReviewsAdmin} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/transactions" component={TransactionsList} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/settings" component={Settings} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/invoicereport" component={Invoicereport} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/currency-settings" component={CurrencySettings} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/profile" component={Profile} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/components" component={Components} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/form-basic" component={FormBasicInputs} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/form-horizontal" component={FormHorizontal} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/form-input-groups" component={FormInputGroups} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/form-mask" component={FormMask} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/form-validation" component={FormValidation} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/form-vertical" component={FormVertical} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/tables-basic" component={Basictables} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/data-tables" component={dataTables} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/blog-page" component={AdminDoctorBlogPage} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/offers" component={createOffers} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/AllOffers" component={AllOffers} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/admin-business" component={AdminBusinessAndAddonPage} layout={AdminDashboardLayout} />
          
//           <this.RegularPrivateRoute path="/admin/NotificationSettings" component={NotificationSettings} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/PaymentSettings" component={PaymentSettings} layout={AdminDashboardLayout} />
//           <this.RegularPrivateRoute path="/admin/VideoSettings" component={VideoSettings} layout={AdminDashboardLayout} />

//           {/* --- DOCTOR DASHBOARD ROUTES WITH SUBSCRIPTION PROTECTION --- */}
          
//           {/* Plan Selection is accessible without active subscription */}
//           <this.DoctorRoute 
//             path="/doctor/plan-selection" 
//             component={PlanSelection} 
//             layout={DoctorDashboardLayout} 
//             requiresSubscription={false} 
//           />
          

//           {/* All other doctor routes require active subscription */}
//           <this.DoctorRoute path="/doctor/reminder-tab" component={ReminderTab} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/Exercise-chart" component={Exercisechart} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/diet-chart" component={DietChart} layout={DoctorDashboardLayout} />
          
//           <this.DoctorRoute path="/doctor/diet-chart" component={LabsAndCenters} layout={DoctorDashboardLayout} />
//            <this.DoctorRoute path="/doctor/diet-chart" component={HomeAndHealthcare} layout={DoctorDashboardLayout} />
//             <this.DoctorRoute path="/doctor/diet-chart" component={PharmacyAndMedicines} layout={DoctorDashboardLayout} />
//            <this.DoctorRoute path="/doctor/diet-chart" component={HealthInsurance} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/payout-history" component={PayoutHistory} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/dashboard" component={DoctorDashboardMain} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/appointments" component={Appointments} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/my-patients" component={PatientListDoctor} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/schedule-timings" component={ScheduleTime} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/invoices" component={DoctorInvoices} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/reviews" component={ReviewsDoctor} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/chat" component={DoctorChat} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/profile-settings" component={DoctorProfileSettings} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/social-media" component={SocialMedia} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/change-password" component={DoctorChangePassword} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/transaction-list" component={DoctorTransactions} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/recordingsLibrary" component={RecordingsLibrary} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/ReportSettingsEditor" component={ReportSettingsEditor} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/add-blog" component={AddBlogs} layout={DoctorDashboardLayout} />
//           <this.DoctorRoute path="/doctor/my-blogs" component={MyBlogs} layout={DoctorDashboardLayout} />

//           {/* --- PATIENT DASHBOARD ROUTES (No subscription required) --- */}
//           <this.RegularPrivateRoute path="/patient/dashboard" component={PatientDashbordMain} layout={PatientDashboardLayout} />
//           <this.RegularPrivateRoute path="/patient/favourites" component={Favourites} layout={PatientDashboardLayout} />
//           <this.RegularPrivateRoute path="/patient/chat" component={PatientChat} layout={PatientDashboardLayout} />
//           <this.RegularPrivateRoute path="/patient/profile-settings" component={PatientProfileSettings} layout={PatientDashboardLayout} />
//           <this.RegularPrivateRoute path="/patient/change-password" component={PatientChangePassword} layout={PatientDashboardLayout} />
//           <this.RegularPrivateRoute path="/patient/family-members" component={AddFamilyMembers} layout={PatientDashboardLayout} />


//           {/* --- OTHER AUTHENTICATED ROUTES (No subscription required) --- */}
//           <this.RegularPrivateRoute exact path="/VoiceCall" component={VoiceCall} />
//           <this.RegularPrivateRoute exact path="/VideoCall" component={VideoCall} />
//           <this.RegularPrivateRoute exact path="/calendar" component={Calender} />
//           <this.RegularPrivateRoute exact path="/invoices" component={Invoice} />
//           <this.RegularPrivateRoute exact path="/invoiceview" component={Invoiceview} />

//           {/* --- FALLBACK REDIRECT --- */}
//           <Redirect to="/" />
//         </Switch>
//       </React.Suspense>
//     );
//   }
// }

// const mapStateToProps = (state) => ({
//   isAuthenticated: state.loginReducer.isAuthenticated,
//   username: state.loginReducer.username,
//   userList: state.loginReducer.userList,
// });

// const mapDispatchToProps = (dispatch) => ({
//   handlelogin: (mobile, password) => dispatch(handlelogin(mobile, password)),
//   getAllUsers: () => dispatch(getAllUsers()),
//   logout: () => dispatch(logout()),
//   dispatch,
// });

// export default connect(mapStateToProps, mapDispatchToProps)(App);

















import './scss/style.scss';
import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import jwtDecode from 'jwt-decode';

import '@fortawesome/fontawesome-free/css/all.min.css';
import { handlelogin, getAllUsers, logout } from "./actions/loginAction";
import { LOGINAUTH } from './actions/types';
import { formatCurrency } from '../src/appoinmentApp/utils/currencyHelper';

// ─── Admin Pages ──────────────────────────────────────────────────────────────
import AdminDashboardMain from './appoinmentApp/admin/AdminDashboardMain';
import appointmentList from './appoinmentApp/admin/appointmentList';
import Specialities from './appoinmentApp/admin/Specialities';
import doctorList from './appoinmentApp/admin/doctorList';
import PatientListAdmin from './appoinmentApp/admin/PatientList';
import ReviewsAdmin from './appoinmentApp/admin/Reviews';
import TransactionsList from './appoinmentApp/admin/TransactionsList';
import Settings from './appoinmentApp/admin/Settings';
import Invoicereport from './appoinmentApp/admin/Invoicereport';
import Profile from './appoinmentApp/admin/Profile';
import FormBasicInputs from './appoinmentApp/admin/FormBasicInputs';
import FormHorizontal from './appoinmentApp/admin/FormHorizontal';
import FormInputGroups from './appoinmentApp/admin/FormInputGroups';
import FormMask from './appoinmentApp/admin/FormMask';
import FormValidation from './appoinmentApp/admin/FormValidation';
import FormVertical from './appoinmentApp/admin/FormVertical';
import Basictables from './appoinmentApp/admin/Basictables';
import dataTables from './appoinmentApp/admin/dataTables';
import AdminPayoutDashboard from './appoinmentApp/admin/AdminPayoutDashboard';
import AdminDoctorBlogPage from './appoinmentApp/admin/AdminDoctorBlogPage';
import createOffers from './appoinmentApp/admin/createOffers';
import AllOffers from './appoinmentApp/admin/AllOffers';
import CurrencySettings from './appoinmentApp/admin/CurrencySettings';
import NotificationSettings from './appoinmentApp/admin/NotificationSettings';
import AdminBusinessAndAddonPage from './appoinmentApp/admin/AdminBusinessAndAddonPage';
import PaymentSettings from './appoinmentApp/admin/PaymentSettings';
import VideoSettings from './appoinmentApp/admin/VideoSettings';

// ─── Doctor Pages ─────────────────────────────────────────────────────────────
import DoctorDashboardMain from './appoinmentApp/doctor/DoctorDashboardMain';
import Appointments from './appoinmentApp/doctor/Appointments';
import PatientListDoctor from './appoinmentApp/doctor/PatientList';
import ScheduleTime from './appoinmentApp/doctor/ScheduleTime';
import DoctorInvoices from './appoinmentApp/doctor/DoctorInvoices';
import ReviewsDoctor from './appoinmentApp/doctor/Reviews';
import DoctorChat from './appoinmentApp/doctor/DoctorChat';
import ReminderTab from './appoinmentApp/doctor/ReminderTab';
import Exercisechart from './appoinmentApp/doctor/Exercisechart';
import DoctorProfileSettings from './appoinmentApp/doctor/DoctorProfileSettings';
import SocialMedia from './appoinmentApp/doctor/SocialMedia';
import DoctorChangePassword from './appoinmentApp/doctor/DoctorChangePassword';
import PatientProfilePage from './appoinmentApp/doctor/PatientProfilePage';
import DoctorTransactions from './appoinmentApp/doctor/DoctorTransactions';
import ReportSettingsEditor from './appoinmentApp/doctor/ReportSettingsEditor';
import PayoutHistory from './appoinmentApp/doctor/PayoutHistory';
import RecordingsLibrary from './appoinmentApp/doctor/RecordingsLibrary';
import PlanSelection from './appoinmentApp/doctor/PlanSelection';
import AddBlogs from './appoinmentApp/doctor/AddBlogs';
import MyBlogs from './appoinmentApp/doctor/MyBlogs';
import DietChart from './appoinmentApp/doctor/DietCharts';

// ─── Patient Pages ────────────────────────────────────────────────────────────
import PatientDashbordMain from './appoinmentApp/patient/PatientDashbordMain';
import Favourites from './appoinmentApp/patient/favourites';
import PatientProfileSettings from './appoinmentApp/patient/PatientProfileSettings';
import AddFamilyMembers from './appoinmentApp/patient/addFamilyMembers';
import PatientChangePassword from './appoinmentApp/patient/PatientChangePassword';
import PatientChat from './appoinmentApp/patient/PatientChat';

// ─── Other Pages ──────────────────────────────────────────────────────────────
import ViewOfferPage from './appoinmentApp/Pages/AllOfferViewPage';
import UIShowcase from '../src/appoinmentApp/Pages/UIShowcase';
import DoctorsBlogPage from './appoinmentApp/Pages/DoctorsBlogPage';
import Aboutus from './appoinmentApp/Footer/Aboutus';
import Contactus from './appoinmentApp/Footer/Contactus';
import Careers from './appoinmentApp/Footer/Careers';
import PartnerWithUs from './appoinmentApp/Footer/PartnerWithUs';
import PrivacyPolicy from './appoinmentApp/Footer/PrivacyPolicy';
import TermsConditions from './appoinmentApp/Footer/TermsConditions';
import RefundCancellationPolicy from './appoinmentApp/Footer/RefundCancellationPolicy';
import Brochure from './appoinmentApp/Footer/Brochure';
import LabsAndCenters from './appoinmentApp/LabsAndCenters';
import HomeAndHealthcare from './appoinmentApp/HomeAndHealthcares';
import HealthInsurance from './appoinmentApp/HealthInsurance';
import PharmacyAndMedicines from './appoinmentApp/PharmacyAndMedicines';

// ─── Loge Pages ───────────────────────────────────────────────────────────────
import MedisevasHospitalErp from './appoinmentApp/logepages/Healthcare Software/MedisevasHospitalErp';
import MedisevasAppointmentPortal from './appoinmentApp/logepages/Healthcare Software/MedisevasAppointmentPortal';
import HospitalAnalyticsManagement from './appoinmentApp/logepages/Healthcare Software/HealthCareAnalytics';
import QueueManagement from './appoinmentApp/logepages/Healthcare Software/QueueManagements';
import TeleHealthCareManagement from './appoinmentApp/logepages/Healthcare Software/TeleHealthCareManagements';
import MedisevasHealthCareImaging from './appoinmentApp/logepages/Healthcare Software/MedisevasHealthCareImaging';
import MateriaMedicaRepertory from './appoinmentApp/logepages/Healthcare Software/MateriaMedicaandRepertory';
import PathologyLabManagement from './appoinmentApp/logepages/Laboratory Software/PathologyLabManagement';
import RadiologyLabManagement from './appoinmentApp/logepages/Laboratory Software/RadiologyLabManagement';
import DentalLabManagement from './appoinmentApp/logepages/Laboratory Software/DentalLabManagement';
import EmbryologyLabManagement from './appoinmentApp/logepages/Laboratory Software/EmbryologyLabManagement';
import EggSpermBankLabManagement from './appoinmentApp/logepages/Laboratory Software/Egg&SpermBankSoftware';
import BloodBankLabManagement from './appoinmentApp/logepages/Laboratory Software/BloodBankManagement';
import AyurvedicClinicManagement from './appoinmentApp/logepages/For Clinic/AyurvedicClinicalModule';
import DentalClinicManagement from './appoinmentApp/logepages/For Clinic/DentalClinicalModule';
import GynecologyClinicalModule from './appoinmentApp/logepages/For Clinic/GynecologyClinicalModule';
import PediatricsClinicalModule from './appoinmentApp/logepages/For Clinic/PediatricClinicalModule';
import OphthalmologyClinicalModule from './appoinmentApp/logepages/For Clinic/OphthalmologyClinicalModule';
import HomeopathyClinicalModule from './appoinmentApp/logepages/For Clinic/HomeopathyClinicalModule';
import IVFClinicalModule from './appoinmentApp/logepages/For Clinic/IVFClinicalModule';
import MedicineClinicalModule from './appoinmentApp/logepages/For Clinic/MedicineClinicalModule';
import OrthopedicClinicalModule from './appoinmentApp/logepages/For Clinic/OrthopedicClinicalModule';
import PhysiotherapyClinicalModule from './appoinmentApp/logepages/For Clinic/PhysiotherapyClinicalModule';

// ─── Section Pages ────────────────────────────────────────────────────────────
import NavStrip from './appoinmentApp/section/NavStrip';
import OfferSection from './appoinmentApp/section/OfferSection';
import BlogSection from './appoinmentApp/section/BlogSection';
import FaqSection from './appoinmentApp/section/FaqSection';
import DownloadSection from './appoinmentApp/section/DownloadSection';
import DebugSubscription from './appoinmentApp/utils/DebugSubscription';
// ─── Lazy Loaded ──────────────────────────────────────────────────────────────
const MessageModal = React.lazy(() => import('./appoinmentApp/Pages/MessageModel'));
const AdminDashboardLayout = React.lazy(() => import('./appoinmentApp/admin/AdminDashboard'));
const DoctorDashboardLayout = React.lazy(() => import('./appoinmentApp/doctor/DoctorDashboard'));
const PatientDashboardLayout = React.lazy(() => import('./appoinmentApp/patient/Patientdashboard'));
const AppoinmentApp = React.lazy(() => import('./appoinmentApp/AppoinmentApp'));
const Login = React.lazy(() => import('./appoinmentApp/Pages/LoginPage'));
const Register = React.lazy(() => import('./appoinmentApp/Pages/Register'));
const Forgot_Password = React.lazy(() => import('./appoinmentApp/Pages/ForgotPassword'));
const ResetPassword = React.lazy(() => import('./appoinmentApp/Pages/ResetPassword'));
const SearchDoctor = React.lazy(() => import('./appoinmentApp/Pages/Searchdoctors'));
const Doctorprofile = React.lazy(() => import('./appoinmentApp/patient/Doctorprofile'));
const Booking = React.lazy(() => import('./appoinmentApp/patient/booking'));
const Checkout = React.lazy(() => import('./appoinmentApp/patient/Checkout'));
const BookingSucess = React.lazy(() => import('./appoinmentApp/patient/bookingSuccess'));
const VoiceCall = React.lazy(() => import('./appoinmentApp/Pages/VoiceCall'));
const VideoCall = React.lazy(() => import('./appoinmentApp/Pages/VideoCall'));
const Calender = React.lazy(() => import('./appoinmentApp/Pages/Calendar'));
const Invoice = React.lazy(() => import('./appoinmentApp/Pages/Invoices'));
const Invoiceview = React.lazy(() => import('./appoinmentApp/Pages/Invoiceview'));
const Components = React.lazy(() => import('./appoinmentApp/Pages/Componants'));
const StarterPage = React.lazy(() => import('./appoinmentApp/Pages/StarterPage'));
const PatientVideoCall = React.lazy(() => import('./appoinmentApp/Pages/PatientVideoCall'));
const DoctorVideoCall = React.lazy(() => import('./appoinmentApp/Pages/DoctorVideoCall'));
const PaymentStatus = React.lazy(() => import('./appoinmentApp/Pages/PaymentStatus'));
const SpecialityDoctorsPage = React.lazy(() => import('./appoinmentApp/Pages/SpecialityDoctorsPage'));

const loading = (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="sr-only">Loading...</span>
        </div>
    </div>
);

class App extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: true };
    }

    componentDidMount() {
        this.rehydrateStateFromLocalStorage();
    }

    // ✅ REHYDRATE — Page refresh hone par localStorage se Redux update karo
    // Image ke step 7: "After login read subscription_status from loginData/localStorage"
    // rehydrateStateFromLocalStorage = () => {
    //     try {
    //         const loginDataString = localStorage.getItem('loginData');
    //         if (!loginDataString) {
    //             this.setState({ loading: false });
    //             return;
    //         }

    //         const loginData = JSON.parse(loginDataString);
    //         const token = loginData.token;

    //         if (!token || (jwtDecode(token).exp * 1000 < Date.now())) {
    //             localStorage.removeItem('loginData');
    //             this.setState({ loading: false });
    //             return;
    //         }

    //         window.formatCurrency = formatCurrency;

    //         // ✅ localStorage mein jo subscription_status hai wo Redux mein dalo
    //         // Isi se page refresh ke baad bhi sidebar sahi rahegi
    //         this.props.dispatch({
    //             type: LOGINAUTH,
    //             payload: {
    //                 success: 1,
    //                 data: {
    //                     ...loginData,
    //                     // Ensure ye fields hain
    //                     subscription_status: loginData.subscription_status || null,
    //                     Subscription_type: loginData.Subscription_type || null,
    //                     app_status: loginData.app_status || 'enabled',
    //                 }
    //             }
    //         });

    //     } catch (error) {
    //         console.error("Failed to rehydrate state:", error);
    //         localStorage.removeItem('loginData');
    //     } finally {
    //         this.setState({ loading: false });
    //     }
    // };
    // App.js - rehydrateStateFromLocalStorage function

// rehydrateStateFromLocalStorage = () => {
//     try {
//         const loginDataString = localStorage.getItem('loginData');
//         if (!loginDataString) {
//             this.setState({ loading: false });
//             return;
//         }

//         const loginData = JSON.parse(loginDataString);
        
//         console.log('[App] Rehydrating with loginData:', {
//             subscription_status: loginData.subscription_status,
//             Subscription_type: loginData.Subscription_type
//         });
        
//         const token = loginData.token;

//         if (!token || (jwtDecode(token).exp * 1000 < Date.now())) {
//             localStorage.removeItem('loginData');
//             this.setState({ loading: false });
//             return;
//         }

//         window.formatCurrency = formatCurrency;

//         // ✅ Force set subscription_status if missing
//         const subscription_status = loginData.subscription_status || 'inactive';
//         const Subscription_type = loginData.Subscription_type || null;

//         this.props.dispatch({
//             type: LOGINAUTH,
//             payload: {
//                 success: 1,
//                 data: {
//                     ...loginData,
//                     subscription_status: subscription_status,
//                     Subscription_type: Subscription_type,
//                     app_status: loginData.app_status || 'enabled',
//                 }
//             }
//         });

//     } catch (error) {
//         console.error("Failed to rehydrate state:", error);
//         localStorage.removeItem('loginData');
//     } finally {
//         this.setState({ loading: false });
//     }
// };
rehydrateStateFromLocalStorage = () => {
    try {
        const loginDataString = localStorage.getItem('loginData');
        if (!loginDataString) {
            this.setState({ loading: false });
            return;
        }

        const loginData = JSON.parse(loginDataString);
        
        console.log('[App] Rehydrating with loginData:', {
            subscription_status: loginData.subscription_status,
            Subscription_type: loginData.Subscription_type
        });
        
        const token = loginData.token;

        if (!token || (jwtDecode(token).exp * 1000 < Date.now())) {
            localStorage.removeItem('loginData');
            this.setState({ loading: false });
            return;
        }

        window.formatCurrency = formatCurrency;

        // ✅ Force set subscription_status if missing
        const subscription_status = loginData.subscription_status || 'inactive';
        const Subscription_type = loginData.Subscription_type || null;

        this.props.dispatch({
            type: LOGINAUTH,
            payload: {
                success: 1,
                data: {
                    ...loginData,
                    subscription_status: subscription_status,
                    Subscription_type: Subscription_type,
                    app_status: loginData.app_status || 'enabled',
                }
            }
        });

        // ✅ ADDED: Hard Refresh Redirect Logic
        const role = loginData.role; 
        if (role === 'Admin') {
            window.location.hash = '#/doctor/dashboard';
        } else if (role === 'SuperAdmin') {
            window.location.hash = '#/admin/dashboard';
        } else if (role === 'Patient') {
            window.location.hash = '#/patient/dashboard';
        }

    } catch (error) {
        console.error("Failed to rehydrate state:", error);
        localStorage.removeItem('loginData');
    } finally {
        this.setState({ loading: false });
    }
};
    // ──────────────────────────────────────────────────────────────────────────
    // PRIVATE ROUTE — Login check only
    // ──────────────────────────────────────────────────────────────────────────
    PrivateRoute = ({ component: Component, layout: Layout, ...rest }) => (
        <Route
            {...rest}
            render={(props) => {
                if (!this.props.isAuthenticated) {
                    return <Redirect to="/login" />;
                }
                return Layout ? <Layout><Component {...props} /></Layout> : <Component {...props} />;
            }}
        />
    );

    // ──────────────────────────────────────────────────────────────────────────
    // DOCTOR ROUTE — Image ke steps 8 & 9:
    //   subscription_status === 'active' → allow karo
    //   subscription_status !== 'active' → plan-selection pe bhejo
    //   requiresSubscription: false wale routes (plan-selection) hamesha open
    // ──────────────────────────────────────────────────────────────────────────
    DoctorRoute = ({ component: Component, layout: Layout, requiresSubscription = true, ...rest }) => (
        <Route
            {...rest}
            render={(props) => {
                // Login check
                if (!this.props.isAuthenticated) {
                    return <Redirect to="/login" />;
                }

                // Sirf Admin role ke liye subscription check karo
                const userRole = this.props.role;
                if (userRole === 'Admin' && requiresSubscription) {
                    const subscriptionStatus = this.props.subscriptionStatus;

                    console.log('[DoctorRoute] subscription_status:', subscriptionStatus);

                    // ✅ Image step 9: subscription active nahi → plan-selection
                    if (subscriptionStatus !== 'active') {
                        console.log('[DoctorRoute] No active subscription → redirecting to plan-selection');
                        return <Redirect to="/doctor/plan-selection" />;
                    }
                }

                // ✅ Image step 8: subscription active → allow
                return Layout ? <Layout><Component {...props} /></Layout> : <Component {...props} />;
            }}
        />
    );

    render() {
        if (this.state.loading) {
            return loading;
        }

        return (
            <React.Suspense fallback={loading}>
               <DebugSubscription /> 
                <Switch>
                    {/* ─── PUBLIC ROUTES ──────────────────────────────────── */}
                    <Route exact path="/" component={AppoinmentApp} />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/register" component={Register} />
                    <Route exact path="/forgotpassword" component={Forgot_Password} />
                    <Route path="/reset-password/:token" component={ResetPassword} />
                    <Route exact path="/searchdoctors" component={SearchDoctor} />
                    <Route path="/Doctorprofile/:hospitalID" component={Doctorprofile} />
                    <Route path="/Booking/:hospitalID" component={Booking} />
                    <Route path="/Checkout/:hospitalID" component={Checkout} />
                    <Route exact path="/booking-success" component={BookingSucess} />
                    <Route exact path="/payment-status" component={PaymentStatus} />
                    <Route exact path="/starterpage" component={StarterPage} />
                    <Route exact path="/patient-profile/:id" component={PatientProfilePage} />
                    <Route exact path="/videopage/:roomName" component={VideoCall} />
                    <Route exact path="/patient-videocall/:roomName" component={PatientVideoCall} />
                    <Route path="/doctorvideopage/:roomName/:patientId" component={DoctorVideoCall} />
                    <Route path="/speciality-doctors/:specialityName?" component={SpecialityDoctorsPage} />
                    <Route exact path="/doctors-blog" component={DoctorsBlogPage} />
                    <Route path="/doctors-blog/:blogId" component={DoctorsBlogPage} />
                    <Route path="/offer-details" component={ViewOfferPage} />
                    <Route path="/ui-showcase" component={UIShowcase} />
                    <Route path="/careers" component={Careers} />
                    <Route path="/about-us" component={Aboutus} />
                    <Route path="/contact-us" component={Contactus} />
                    <Route path="/partner-with-us" component={PartnerWithUs} />
                    <Route path="/privacy-policy" component={PrivacyPolicy} />
                    <Route path="/terms-conditions" component={TermsConditions} />
                    <Route path="/refund-cancellation-policy" component={RefundCancellationPolicy} />
                    <Route exact path="/LabsAndCenters" component={LabsAndCenters} />
                    <Route exact path="/HomeAndHealthcare" component={HomeAndHealthcare} />
                    <Route exact path="/PharmacyAndMedicines" component={PharmacyAndMedicines} />
                    <Route exact path="/HealthInsurance" component={HealthInsurance} />
                    <Route path="/brochure" component={Brochure} />
                    <Route path="/navstrip" component={NavStrip} />
                    <Route path="/medisevas-hospital-erp" component={MedisevasHospitalErp} />
                    <Route path="/medisevas-appointment-Portal" component={MedisevasAppointmentPortal} />
                    <Route path="/hospital-analytics-management" component={HospitalAnalyticsManagement} />
                    <Route path="/queue-management" component={QueueManagement} />
                    <Route path="/teleHealthCare-management" component={TeleHealthCareManagement} />
                    <Route path="/medisevas-healthCare-imaging" component={MedisevasHealthCareImaging} />
                    <Route path="/materia-medica-repertory" component={MateriaMedicaRepertory} />
                    <Route path="/pathology-lab-management" component={PathologyLabManagement} />
                    <Route path="/radiology-lab-management" component={RadiologyLabManagement} />
                    <Route path="/dental-lab-management" component={DentalLabManagement} />
                    <Route path="/embryology-lab-management" component={EmbryologyLabManagement} />
                    <Route path="/egg-sperm-bank-management" component={EggSpermBankLabManagement} />
                    <Route path="/blood-bank-management" component={BloodBankLabManagement} />
                    <Route path="/ayurvedic-clinic-management" component={AyurvedicClinicManagement} />
                    <Route path="/dental-clinic-management" component={DentalClinicManagement} />
                    <Route path="/gynecology-clinic-management" component={GynecologyClinicalModule} />
                    <Route path="/pediatrics-clinic-management" component={PediatricsClinicalModule} />
                    <Route path="/ophthalmology-clinic-management" component={OphthalmologyClinicalModule} />
                    <Route path="/homeopathy-clinic-management" component={HomeopathyClinicalModule} />
                    <Route path="/ivf-clinic-management" component={IVFClinicalModule} />
                    <Route path="/medicine-clinic-management" component={MedicineClinicalModule} />
                    <Route path="/orthopedic-clinic-management" component={OrthopedicClinicalModule} />
                    <Route path="/physiotherapy-clinic-management" component={PhysiotherapyClinicalModule} />
                    
                    {/* ─── ADMIN ROUTES ───────────────────────────────────── */}
                    <this.PrivateRoute path="/admin/dashboard" component={AdminDashboardMain} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/payouts" component={AdminPayoutDashboard} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/appointments" component={appointmentList} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/specialities" component={Specialities} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/doctors" component={doctorList} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/patients" component={PatientListAdmin} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/reviews" component={ReviewsAdmin} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/transactions" component={TransactionsList} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/settings" component={Settings} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/invoicereport" component={Invoicereport} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/currency-settings" component={CurrencySettings} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/profile" component={Profile} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/blog-page" component={AdminDoctorBlogPage} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/offers" component={createOffers} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/AllOffers" component={AllOffers} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/admin-business" component={AdminBusinessAndAddonPage} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/NotificationSettings" component={NotificationSettings} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/PaymentSettings" component={PaymentSettings} layout={AdminDashboardLayout} />
                    <this.PrivateRoute path="/admin/VideoSettings" component={VideoSettings} layout={AdminDashboardLayout} />

                    {/* ─── DOCTOR ROUTES ──────────────────────────────────── */}

                    {/* ✅ Image step 9: Plan Selection — subscription ki zarurat nahi */}
                    {/* requiresSubscription: false → hamesha accessible */}
                    <this.DoctorRoute
                        path="/doctor/plan-selection"
                        component={PlanSelection}
                        layout={DoctorDashboardLayout}
                        requiresSubscription={false}
                    />

                    {/* ✅ Image step 8 & 9: Baaki sab routes subscription chahiye */}
                    <this.DoctorRoute path="/doctor/dashboard" component={DoctorDashboardMain} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/appointments" component={Appointments} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/my-patients" component={PatientListDoctor} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/schedule-timings" component={ScheduleTime} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/invoices" component={DoctorInvoices} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/reviews" component={ReviewsDoctor} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/chat" component={DoctorChat} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/reminder-tab" component={ReminderTab} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/Exercise-chart" component={Exercisechart} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/diet-chart" component={DietChart} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/profile-settings" component={DoctorProfileSettings} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/social-media" component={SocialMedia} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/change-password" component={DoctorChangePassword} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/transaction-list" component={DoctorTransactions} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/recordingsLibrary" component={RecordingsLibrary} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/ReportSettingsEditor" component={ReportSettingsEditor} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/add-blog" component={AddBlogs} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/my-blogs" component={MyBlogs} layout={DoctorDashboardLayout} />
                    <this.DoctorRoute path="/doctor/payout-history" component={PayoutHistory} layout={DoctorDashboardLayout} />

                    {/* ─── PATIENT ROUTES ─────────────────────────────────── */}
                    <this.PrivateRoute path="/patient/dashboard" component={PatientDashbordMain} layout={PatientDashboardLayout} />
                    <this.PrivateRoute path="/patient/favourites" component={Favourites} layout={PatientDashboardLayout} />
                    <this.PrivateRoute path="/patient/chat" component={PatientChat} layout={PatientDashboardLayout} />
                    <this.PrivateRoute path="/patient/profile-settings" component={PatientProfileSettings} layout={PatientDashboardLayout} />
                    <this.PrivateRoute path="/patient/change-password" component={PatientChangePassword} layout={PatientDashboardLayout} />
                    <this.PrivateRoute path="/patient/family-members" component={AddFamilyMembers} layout={PatientDashboardLayout} />

                    {/* ─── OTHER AUTH ROUTES ──────────────────────────────── */}
                    <this.PrivateRoute exact path="/VoiceCall" component={VoiceCall} />
                    <this.PrivateRoute exact path="/VideoCall" component={VideoCall} />
                    <this.PrivateRoute exact path="/calendar" component={Calender} />
                    <this.PrivateRoute exact path="/invoices" component={Invoice} />
                    <this.PrivateRoute exact path="/invoiceview" component={Invoiceview} />

                    <Redirect to="/" />
                </Switch>
            </React.Suspense>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: state.loginReducer.isAuthenticated,
    username: state.loginReducer.username,
    role: state.loginReducer.role,
    // ✅ Image step 7, 8, 9 ke liye — subscription_status Redux se lo
    subscriptionStatus: state.loginReducer.subscriptionStatus,
    subscriptionType: state.loginReducer.subscriptionType,
});

const mapDispatchToProps = (dispatch) => ({
    handlelogin: (mobile, password) => dispatch(handlelogin(mobile, password)),
    getAllUsers: () => dispatch(getAllUsers()),
    logout: () => dispatch(logout()),
    dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);